

export default {
  init () {
    $('.global-header .toggle-btn').click(function () {
      $('body').toggleClass('mw-noscroll-md')
      $('.global-header').toggleClass('is-expand')
    })

    $('.submenu > .title').on('click', function () {
      $(this).parent().toggleClass('is-open')
    })
    $('.submenu')
    .mouseenter(function () {
      if ($(document).width() > 768) {
        var that = $(this)
        clearTimeout(window.hoverTimer)
        window.hoverTimer = setTimeout(function () {
          that.addClass('is-open')
        }, 300)
      }
    })
    .mouseleave(function () {
      if ($(document).width() > 768) {
        clearTimeout(window.hoverTimer)
        $(this).removeClass('is-open')
      }
    });

    $(window).resize(function() {
      if ($(document).width() > 768) {
        $('body').removeClass('mw-noscroll-md')
        $('.global-header').removeClass('is-expand')
      }
    })
  }
}